import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import { getApiCall, postFormApiCall } from "../../../utils/api";
import tableIcons from "../../component/MaterialIcon";

const SendNotification = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await getApiCall("notification/get/all");
    res.data.forEach((d, i) => (d.serial = i + 1));
    setData(res.data);
    setLoading(false);
  };

  const columns = [
    { title: "Sl. no", field: "serial" },
    {
      title: "Image",
      render: (rowData) => (
        <img src={rowData.image_link} height={50} width={50} />
      ),
    },
    { title: "Title", field: "title" },
    { title: "Description", field: "description" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("link", imageLink);

    const res = await postFormApiCall("notification-send", formData);
    setLoading(false);

    if (res.error) {
      return Swal.fire("Error", res.message, "error");
    }

    Swal.fire("Success", res.message, "success");
    setTitle("");
    setDescription("");
    setImageLink("");
    fetchData();
  };

  return (
    <>
      <CircleSpinnerOverlay loading={loading} />

      {/* Form */}
      <section className="content">
        <div className="container-fluid">
          <div className="card card-primary">
            <div className="card-header">
              <h3 className="card-title">Send Notification</h3>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card-body row">
                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Image Link"
                    value={imageLink}
                    onChange={(e) => setImageLink(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="card-footer">
                <button className="btn btn-primary">Send</button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Table */}
      <section className="content">
        <ThemeProvider theme={defaultMaterialTheme}>
          <MaterialTable
            icons={tableIcons}
            title="Notifications"
            columns={columns}
            data={data}
            onRowClick={(e, row) => setSelectedRow(row.tableData.id)}
          />
        </ThemeProvider>
      </section>
    </>
  );
};

export default SendNotification;
